module.exports = __webpack_public_path__ + "static/media/hd-icon.5198cc74.svg";